module.exports = __webpack_public_path__ + "static/media/nav_01.a72a5924.svg";